module.exports = __webpack_public_path__ + "static/kf-right-image-783fb11995d909da87bd7fafd39747e0.png";